{
  "activity_page": {
    "title": "Activity",
    "description": "See your latest orders and quotes, and how your sales are performing.",
    "footer": "Learn more about orders"
  }
}
